import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import {getUrlParameters} from '../../../common/util/urlParameters';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsSkills = (params) => apiActionCreator({
  'endpoint': `/wts/catalog/skills${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_SKILLS,
    ActionTypes.FETCHED_WTS_SKILLS,
    [
      ActionTypes.FETCHED_WTS_SKILLS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});


export const changeWtsSkillSelected = (skillSelected) => ({
  'type': ActionTypes.CHANGE_WTS_SKILL_SELECTED,
  'payload': skillSelected,
});

export const createWtsSkill = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/skills?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_SKILLS,
        [
          () => {
            dispatch(getWtsSkills({'area': areaSelectedId}));
            return {'type': ActionTypes.CREATED_WTS_SKILLS};
          },
          MessageActions.addMessageBoxInfo('Área de curso creada satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_SKILLS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsSkill = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/skills?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_SKILLS,
        [
          () => {
            dispatch(getWtsSkills({'area': areaSelectedId}));
            return {'type': ActionTypes.UPDATED_WTS_SKILLS};
          },
          MessageActions.addMessageBoxInfo('Área de curso modificado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_SKILLS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
